import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// import BootstrapTable from 'react-bootstrap-table-next';
// import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import '../subscriptions.css';
// import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
// import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
// import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';


class ViewTreatment extends Component {
    constructor(props) {
        super(props);
      }

  render() {
    return (

    <div className="modal fade" id="view_treatment_modal" tabIndex="-1" role="dialog" aria-labelledby="RejectModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Treatment Details</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-xl-8 offset-xl-2">
                        <div className="form-group m-form__group row justify-content-center">
                          <div className="m-portlet col-md-12">
                            <div className="m-portlet__body  m-portlet__body--no-padding">
                              <div className="row m-row--no-padding m-row--col-separator-xl">
                                  <div className="col-md-6 col-sm-12 widget-border-bottom">
                                    <div className="m-widget24">
                                      <div className="m-widget24__item mt-4 mb-4 row">
                                        <h4 className="m-widget24__title-custom justify-content-center col-md-12">
                                          <i className="la la-medkit"></i>
                                        </h4>
                                      </div>
                                      <div className="m-widget24__item justify-content-center row pb-3">
                                        <h4 className="m-widget24__title-custom font-size-175">formula 1</h4>
                                      </div>
                                      <div className="m-widget24__item justify-content-center row pb-1">
                                        <h4 className="m-widget24__title-custom pr-2">Strength:</h4>
                                        <span className="m-widget24__title-custom m--font-brand">300mg/7ml</span>
                                      </div>
                                      <div className="m-widget24__item justify-content-center dose-times mb-4 row">
                                        <h4 className="m-widget24__title-custom pr-2">Dose:</h4>
                                        <h4 className="m-widget24__title-custom">12mg/2lb 3x a day</h4>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6 col-sm-12 widget-border-bottom">
                                    <div className="m-widget24">
                                      <div className="m-widget24__item mt-4 mb-4 row">
                                      <h4 className="m-widget24__title-custom justify-content-center col-md-12">
                                      <span className="m-topbar__userpic"><img src="https://s3.amazonaws.com/uploads.development.petpos/uploads/4/medical-records/avatar/1539940222832_116204.jpg" className="m--img-rounded m-width-58" alt=""/></span>
                                      </h4>
                                      </div>
                                      <div className="m-widget24__item pb-3 col-md-12 ">
                                        <div className="row">
                                          <div className="col-md-4">
                                            <h4 className="m-widget24__title-custom pr-2 justify-content-center">Pet Id:</h4>
                                            <h4 className="m-widget24__title-custom px-2 justify-content-center">1121</h4>
                                          </div>
                                          <div className="col-md-3">
                                            <h4 className="m-widget24__title-custom pr-2 justify-content-center">Weight:</h4>
                                            <span className="m-widget24__title-custom m--font-brand justify-content-center">20 lb</span>
                                          </div>
                                          <div className="col-md-5">
                                            <h4 className="m-widget24__title-custom pr-2 justify-content-center">Birthday:</h4>
                                            <h4 className="m-widget24__title-custom justify-content-center">2018-08-07</h4>
                                          </div>
                                        </div>
                                      </div> 
                                      <div className="m-widget24__item pb-3 col-md-12" >
                                        <div className="row px-3">
                                          <div className="col-md-4 pt-3 pb-3" style={{borderTop:'1px dotted #c8c8c8'}}>
                                            <h4 className="m-widget24__title-custom pr-2 justify-content-center">Gender:</h4>
                                            <h4 className="m-widget24__title-custom justify-content-center">Male</h4>
                                          </div>
                                          <div className="col-md-8 pt-3 pb-3" style={{borderTop:'1px dotted #c8c8c8'}}>
                                            <h4 className="m-widget24__title-custom pr-2 justify-content-center">Breeder:</h4>
                                            <h4 className="m-widget24__title-custom justify-content-center">German Shepherd</h4>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                              </div>
                              <div className="row m-row--no-padding m-row--col-separator-xl">
                                  <div className="col-md-6 col-sm-12 widget-border-bottom">
                                    <div className="m-widget24">
                                      <div className="m-widget24__item mt-4 mb-4 row">
                                      <h4 className="m-widget24__title-custom justify-content-center col-md-12">
                                      <i className="la la-tint"></i>
                                      </h4>
                                      </div>
                                      <div className="m-widget24__item justify-content-center row">
                                      <h4 className="m-widget24__title-custom pr-2">Dosage:</h4>
                                      <span className="m-widget24__stats-custom m--font-brand">2.80 ml </span>
                                      </div>
                                      <div className="m-widget24__item mb-4 row">
                                      <h2 className="m-widget24__title-custom dose-times col-md-12">3x a day</h2>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6 col-sm-12 widget-border-bottom">
                                    <div className="m-widget24">
                                      <div className="m-widget24__item mt-4 mb-4 row">
                                      <h4 className="m-widget24__title-custom justify-content-center col-md-12">
                                      <i className="la la-clock-o"></i>
                                      </h4>
                                      </div>
                                      <div className="m-widget24__item justify-content-center row">
                                      <h4 className="m-widget24__title-custom pr-2">Duration:</h4>
                                      <span className="m-widget24__stats-custom m--font-brand">5 days</span>
                                      </div>
                                      <div className="m-widget24__item justify-content-center dose-times mb-4 row">
                                      <h4 className="m-widget24__title-custom pr-2">Recommended:</h4>
                                      <h4 className="m-widget24__title-custom">6 - 14 days</h4>
                                      </div>
                                    </div>
                                  </div>
                              </div>
                              <div className="row m-row--no-padding m-row--col-separator-xl mb-4">
                                  <div className="col-md-6 col-sm-12">
                                    <div className="m-widget24">
                                      <div className="m-widget24__item justify-content-center row">
                                        <h4 className="m-widget24__title-custom pt-4">Start Date:</h4>
                                      </div>
                                      <div className="m-widget24__item row">
                                        <h2 className="m-widget24__title-custom dose-times col-md-12">2018-10-19</h2>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-6 col-sm-12">
                                    <div className="m-widget24">
                                      <div className="m-widget24__item justify-content-center row">
                                        <h4 className="m-widget24__title-custom pt-4">End Date:</h4>
                                      </div>
                                      <div className="m-widget24__item row">
                                        <h2 className="m-widget24__title-custom dose-times col-md-12">2018-10-24</h2>
                                      </div>
                                    </div>
                                  </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
            </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
});


export default withRouter(connect(mapStateToProps)(ViewTreatment));